import React, { useEffect, useState } from 'react';
import { Divider, Popover, Spin, Tooltip } from 'antd';
import { FiLogOut } from 'react-icons/fi';
import { isEmpty } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { IoIosArrowDropright, IoIosArrowDropleft } from 'react-icons/io';
import { AiOutlineDownload } from 'react-icons/ai';
import CloseIcon from '@mui/icons-material/Close';

import Button from '../../components/uiComponent/button/index.js';

import { HeaderWrapper } from './style.js';

import { setItem, SignOut } from '../../slices/auth.js';
import { getLatestFileUpload, markUploadAsSeen } from '../../slices/po.js';

import { Header } from '../layout/style.js';
import ProgressBar from '../uiComponent/progressBar/index.js';
import { color } from 'highcharts';
import { Refresh } from '@mui/icons-material';
import { IconButton } from '@mui/material';

const { STORAGE_ICON_URL } = require('../../constants/storage.js');

const Logo = `${STORAGE_ICON_URL}/logo-1.svg`;
const BellIcon = `${STORAGE_ICON_URL}/bell-notification.svg`;
const Arrow = `${STORAGE_ICON_URL}/down-arrow.svg`;

const NewHeader = ({ tab, setCollapsed, collapsed }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [fileInfo, setFileInfo] = useState({});
  const [refresh, setRefresh] = useState(false);
  const [closedHeader, setClosedHeader] = useState(false);

  const { currentUser, parentUser, showFileHeader } = useSelector(state => state?.auth || {});
  const { fetchingLatestFileUpload } = useSelector(state => state?.pos || {});

  const haveNotFileUploadHeaderPermission = currentUser?.is_employee_of && !currentUser?.permissions?.includes(5);

  let user = {};
  if (!isEmpty(parentUser)) user = parentUser;
  else user = currentUser;
  const splitedName = user?.full_name?.toUpperCase()?.split(' ') || [];
  const abbreviatedName = `${splitedName?.[0]?.[0] || ''}${splitedName?.[1]?.[0] || ''}`;

  const UserPopoverContent = () => {
    return (
      <HeaderWrapper isNewHeader={true}>
        <div className="user-dropdown">
          <div className="d-flex grid-column-gap-10 marginy-8">
            <div>
              <span className="icon-user fs-16"></span>
            </div>
            <div className="d-flex flex-column grid-column-2">
              <Tooltip title={user?.full_name}>
                <span className="username fs-14 tw-whitespace-nowrap tw-max-w-[120px] tw-truncate">{user?.full_name}</span>
              </Tooltip>
              <Tooltip title={user?.email}>
                <span className="email tw-max-w-[120px] tw-truncate">{user?.email}</span>
              </Tooltip>
              {/* <span className="role color-secondary fs-14">{user?.role?.name}</span> */}
              <span className="role color-secondary fs-14">{user?.company?.name}</span>
            </div>
          </div>
          <hr />
          <div onClick={() => {
            dispatch(SignOut());
            navigate('/auth/sign-in', { replace: true });
          }} className="logout grid-column-gap-10 d-flex">
            <div>
              <FiLogOut className="color-primary" />
            </div>
            <span >Logout</span>
          </div>
        </div>
      </HeaderWrapper>
    );
  };

  useEffect(() => {
    // if (haveNotFileUploadHeaderPermission){
    //   return;
    // }
    dispatch(getLatestFileUpload({
      user_id: currentUser.is_employee_of ? currentUser.is_employee_of : currentUser?.id
    })).then((res) => {
      if (res?.payload?.success && res?.payload?.data) {
        setFileInfo(res?.payload?.data);
        res?.payload?.data?.is_seen && setClosedHeader(true);
      } else {
        setFileInfo({});
      }
    });
  }, [refresh]);

  let status = 'grey';
  if (fileInfo?.success_records === 0 || fileInfo.status === 'inProgress') {
    status = 'grey';
  } else if (fileInfo?.total_records === fileInfo?.success_records) {
    status = 'success';
  } else if (fileInfo?.success_records < fileInfo?.total_records) {
    status = 'warning';
  }

  const closeHeader = (fileId) => {
    dispatch(setItem({
      field: 'showFileHeader',
      value: false
    }));
    dispatch(markUploadAsSeen({
      id: fileId
    }));
    setClosedHeader(true);
  };

  const refreshFile = () => {
    setRefresh((prev) => !prev);
  };


  return (
    <Header collapsed={collapsed}>
      <img
        src={Logo}
        alt="Logo"
        title="Logo"
        onClick={() => navigate(user?.role?.name === 'Warehouse' ? '/warehouse-location' : '/inventory/sku')} 
        style={{ cursor: 'pointer', visibility: 'hidden' }}
      />
      <span onClick={() => setCollapsed(!collapsed)} className='icon-wrapper'>
        {collapsed ? <IoIosArrowDropright /> : <IoIosArrowDropleft />}
      </span>
      <div className="logo-page-title">
        <div className="page-title">
          {
            tab.parent ?
              <>
                <span>{tab.parent}</span>
                <span>/</span>
              </> : null
          }
          <span>{tab.child}</span>
        </div>
        {
          ( (fileInfo?.length !== 0 && !closedHeader || showFileHeader) ) &&
          <Spin spinning={fetchingLatestFileUpload}>
            <div className="file-upload-section">
                <div className="file-info">
                  <span>Name: </span>
                  <Tooltip title={fileInfo?.file_name}>
                    <span>{fileInfo?.file_name}</span>
                  </Tooltip>
                </div>
              <Divider type="vertical" />
                <div className="file-info">
                  <span>Type</span>
                  <Tooltip title={fileInfo?.file_type}>
                    <span> {fileInfo?.file_type}</span>
                  </Tooltip>
                </div>
              <Divider type="vertical" />
              <div className="file-info">
                <span>Status</span>
                <span style={{ color: fileInfo?.status === 'inProgress' ? '#F8C859' : 'green' }}>
                  {fileInfo?.status ? (fileInfo?.status === 'inProgress' ? 'In Progress' : 'Completed') : ''}
                </span>
              </div>
              <Divider type="vertical" />
              <div className="file-info">
                <ProgressBar
                  status={status}
                  simpleProgress
                  className="header-bar-placement"
                  labelText="Packed"
                  current={fileInfo.status === 'completed' ? fileInfo?.success_records : '0'}
                  total={fileInfo.status === 'completed' ? fileInfo?.total_records : '0'}
                  Width={119}
                />
              </div>
              <Divider type="vertical" />
              <div className="file-info">
                <Button
                  className="file-info-header-btn"
                  disabled={haveNotFileUploadHeaderPermission}
                  endIcon={<span className="count-cal">{fileInfo.status === 'completed' ? (fileInfo?.error_records < 100 ? fileInfo?.error_records : '99+') : '0'}</span>}
                  startIcon={<AiOutlineDownload />}
                  text='Error'
                  onClick={() => navigate('/file-upload-history')}
                />
              </div>
              <IconButton
              onClick={refreshFile}
              >
                <Refresh sx={{ color: '#1565D8', fontSize: '16px', cursor: 'pointer' }} />
              </IconButton>
              <IconButton
              size="small"
                sx={{
                  position: 'absolute', p: 0, bgcolor: '#ff4d4f', top: '-9px', right: '-8px', '& :hover': {
                    borderRadius: '50%'
                  }
                }}
                onClick={() => closeHeader(fileInfo.id)} >
                <CloseIcon fontSize="inherit" sx={{ color: 'white' }} />
              </IconButton>
            </div>
          </Spin>
        }
        <div className="actions">
          <img src={BellIcon} alt={BellIcon} title={BellIcon} />
          <div className="divider" />
          <Popover trigger="click" placement="bottomRight" content={<UserPopoverContent />}>
            <div className="user-title">{abbreviatedName}<img src={Arrow} title={Arrow} alt={Arrow} /></div>
          </Popover>
        </div>
      </div>
    </Header>
  );
};

export default NewHeader;
